import TagGroup from "components/tags/TagGroup";
import Container from "hardcover-ui/components/Container";
import { PageSerializersBooksShow } from "types/serializers";

export default function BookTags({ book }: { book: PageSerializersBooksShow }) {
  const tagGroups =
    (book.genres.length > 0 ? 1 : 0) +
    (book.moods.length > 0 ? 1 : 0) +
    (book.contentWarnings?.length > 0 ? 1 : 0);

  const genres = book.genres || [];
  const moods = book.moods || [];
  const contentWarnings = book.contentWarnings || [];

  if (
    genres.length === 0 &&
    moods.length === 0 &&
    contentWarnings.length === 0
  ) {
    return <></>;
  }

  return (
    <Container size="md">
      <h2 className="sr-only">Tags</h2>
      <div className={`grid grid-cols-1 lg:grid-cols-${tagGroups} gap-4`}>
        <TagGroup tags={genres} />
        <TagGroup tags={moods} />
        <TagGroup tags={contentWarnings} />
      </div>
    </Container>
  );
}
